<template>
	<div class="s-pt-40 s-min-h-screen s-text-center">
		<Transition name="bounce">
			<div
				v-if="isIntroVisible"
				class="s-w-full md:s-w-5/12 s-m-auto  s-bg-white s-rounded-lg s-shadow-xl s-border s-border-gray-200 s-p-10"
			>
				<img src="@/assets/img/logo.svg" alt="" class="s-h-8 s-m-auto s-mt-12 s-mb-12" />
				<!-- <div class="text-2xl mb-4 font-bold leading-normal text-gray-600 uppercase">Nocode Studio</div> -->
				<div class="s-text-xl s-leading-normal s-text-gray-600">
					{{ $t("dashboard.createAndLaunch") }}
				</div>
				<div class="s-mt-16 s-mb-10">
					<!-- MOCK: some buttons should be eventually removed -->
					<!-- Default -->
					<!-- <div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-xs">Default</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-sm">Default</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default">Default</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-lg">Default</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-xl">Default</JButton>
					</div> -->

					<!-- Default Light -->
					<!-- <div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-light-xs">Default Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-light-sm">Default Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-light">Default Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-light-lg">Default Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="default-light-xl">Default Light</JButton>
					</div> -->

					<!-- White -->
					<!-- <div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="white-xs">White</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="white-sm">White</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="white">White</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="white-lg">White</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="white-xl">White</JButton>
					</div> -->

					<!-- Error -->
					<!-- <div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-xs">Error</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-sm">Error</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error">Error</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-lg">Error</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-xl">Error</JButton>
					</div> -->

					<!-- Error Light -->
					<!-- <div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-light-xs">Error Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-light-sm">Error Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-light">Error Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-light-lg">Error Light</JButton>
					</div>
					<div class="s-w-full s-flex s-justify-center s-mb-2">
						<JButton variant="error-light-xl">Error Light</JButton>
					</div> -->

					<JButton variant="default-xl" :to="{ name: 'ViewProductsHome' }">{{ $t("dashboard.startBuilding") }}</JButton>
				</div>
			</div>
		</Transition>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			isIntroVisible: false
		}
	},

	mounted() {
		setTimeout(() => {
			this.isIntroVisible = true
		}, 50)
	}
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.bounce-enter-active {
	animation: bounce-in 0.5s;
}
.bounce-leave-active {
	animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
	0% {
		opacity: 0;
		transform: translateY(-40px) scale(0.94);
	}

	100% {
		transform: translateY(0);
		opacity: 1;
		transform: scale(1);
	}
}
</style>
